import styled from 'styled-components';
import { Body2 } from 'ui/theme/typography';
import { colors, spacing } from 'ui/theme';

export const Wrapper = styled.div`
  border: solid ${spacing.single} ${colors.borderPrimary};
  border-radius: ${spacing.quarter};
`;

export const Header = styled.div`
  background: ${colors.backgroundSecondary};
  padding: ${spacing.plusHalf};
  border-top-left-radius: ${spacing.quarter};
  border-top-right-radius: ${spacing.quarter};
`;

export const Body2NoMargin = styled(Body2)`
  margin: 0;
`;

export const ProjectRow = styled.div`
  display: grid;
  align-items: center;
  padding: ${spacing.plusHalf};
  grid-template-columns: 1fr 1fr auto;
  &:first-child {
    border-top: solid ${spacing.single} ${colors.borderPrimary};
  }
  &:not(:first-child) {
    border-bottom: solid ${spacing.single} ${colors.borderPrimary};
  }
`;

export const InlineFlexRow = styled.div`
  display: inline-flex;
  gap: ${spacing.half};
`;
